import {
  createInsetMap,
  getInsetBounds,
  addInsetLayer,
  updateInsetLayer,
} from './insetMapUtils.js';
import { state } from './state.js';

/**
 * Initialize and optionally attach inset map.
 * @param {maplibregl.Map} mainMap
 * @param {Object} config - Global config
 * @returns {maplibregl.Map|null} The inset map instance, or null if not used
 */
export function initInsetMap(mainMap, config) {
  const mapInsetElement = document.getElementById('mapInset');

  if (config.inset && !config.legend) {
    const center = config.chapters[0].location.center;

    if (mapInsetElement) {
      mapInsetElement.style.display = 'block'; // explicitly show
    }

    return createInsetMap(config, center);
  }

  // No need to hide here anymore; it's hidden by default
  return null;
}


/**
 * Starts tracking bounds from main map and updates inset box.
 * @param {maplibregl.Map} mainMap
 * @param {maplibregl.Map} insetMap
 */
export function setupInsetMapTracking(mainMap, insetMap) {
  mainMap.on('move', () => {
    const boundsGeoJSON = getInsetBounds(mainMap);

    if (state.insetMapInitLoad) {
      addInsetLayer(insetMap, boundsGeoJSON);
      state.insetMapInitLoad = false;
    } else {
      updateInsetLayer(insetMap, boundsGeoJSON);
    }
  });
}
